<template>
    <v-dialog
        v-model="dialog"
        :retain-focus="false"
        persistent
        max-width="500px"
    >
        <v-card>
            <v-card-title class="headline">
                Update Scheduled For
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <div class="mb-4">
                                <strong>Packing List:</strong>
                                {{ packingList?.code || '-' }}
                            </div>
                            <v-menu
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                :disabled="loading"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="scheduledForDate"
                                        label="Scheduled For"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        dense
                                        :disabled="loading"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="scheduledForDate"
                                    @input="dateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="handleClose"
                    :disabled="loading"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    @click="handleSave"
                    :loading="loading"
                    :disabled="!scheduledForDate"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import API from '@/services/api'
import moment from 'moment'
import { mapMutations } from 'vuex'

export default {
    name: 'EditScheduledForDialog',
    props: {
        packingList: {
            type: Object,
            default: null,
        },
        dialog: {
            type: Boolean,
            default: false,
        },
        projectId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            scheduledForDate: '',
            dateMenu: false,
            loading: false,
        }
    },
    watch: {
        dialog(newVal) {
            if (newVal && this.packingList) {
                // Format current scheduledFor date
                if (this.packingList.scheduledFor) {
                    this.scheduledForDate = moment(
                        this.packingList.scheduledFor
                    ).format('YYYY-MM-DD')
                } else {
                    this.scheduledForDate = ''
                }
            }
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),

        async handleSave() {
            if (!this.scheduledForDate || !this.packingList) {
                return
            }

            try {
                this.loading = true
                await API.updatePackingList({
                    projectId: this.projectId,
                    packingListId: this.packingList.id,
                    scheduledFor: this.scheduledForDate,
                })

                this.$emit('updated', {
                    packingListId: this.packingList.id,
                    scheduledFor: this.scheduledForDate,
                })
                this.handleClose()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        handleClose() {
            this.scheduledForDate = ''
            this.dateMenu = false
            this.$emit('close')
        },
    },
}
</script>

<style scoped>
</style>

